import { render, staticRenderFns } from "./chevron-top.vue?vue&type=template&id=72369905&scoped=true&"
import script from "./chevron-top.vue?vue&type=script&lang=js&"
export * from "./chevron-top.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72369905",
  null
  
)

export default component.exports